/**
 * @author: yanhoup
 * @description: 出库路由配置
 */
import React from 'react';
import Packbox from '@/pages/Packbox';
import PackDetail from '@/pages/Packdetail';
import Packfind from '@/pages/Packfind';
import Packstep from '@/pages/Packstep';
import Packabnor from '@/pages/Packabnor';
import Deliver from '@/pages/Deliver';
import Deliverfind from '@/pages/Deliverfind';
import DeliverStep from '@/pages/DeliverStep';
import DeliverAbnor from '@/pages/DeliverAbnor';
import SortAbnormalList from '@/pages/SortAbnormalList';
import SortDetail from '@/pages/SortDetail';
import SortDetailList from '@/pages/SortDetailList';
import SortList from '@/pages/SortList';
import SortStepList from '@/pages/SortStepList';
import PickList from '@/pages/PickList';
import PickDetail from '@/pages/PickDetail';
import PickDetailList from '@/pages/PickDetailList';
import PickStepList from '@/pages/PickStepList';
import PickAbnormalList from '@/pages/PickAbnormalList';
import PickQueueList from '@/pages/PickQueueList';
import PickQueueDetail from '@/pages/PickQueueDetail';
import PickManualRemitList from '@/pages/PickManualRemitList';
import PickManualRemitListDetail from '@/pages/OutboundOrderDetail';
import OperatePack from '@/pages/OperatePack';
import DeliverDetail from '@/pages/DeliverDetail';
import DeliverCarDetail from '@/pages/DeliverCarDetail';
import OneSortingList from '@/pages/OneSorting/List';
import OneSortingDetail from '@/pages/OneSorting/Detail';
import OneSortingDetailedList from '@/pages/OneSortingDetailed/List';
import SortingCollectList from '@/pages/SortingCollect/List';
import SortingCollectDetail from '@/pages/SortingCollect/Detail';
import SortingCollectDetailedList from '@/pages/SortingCollectDetailed/List';

export default [
  {
    path: '/outbound/sort/list',
    // component: SortList,
    component: React.lazy(() => import(/* webpackChunkName: 'SortList' */ '@/pages/SortList')),
  },
  {
    path: '/outbound/sort/detail',
    // component: SortDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'SortDetail' */ '@/pages/SortDetail')),
  },
  {
    path: '/outbound/sort/detailList',
    // component: SortDetailList,
    component: React.lazy(() => import(/* webpackChunkName: 'SortDetailList' */ '@/pages/SortDetailList')),
  },
  {
    path: '/outbound/sort/stepList',
    // component: SortStepList,
    component: React.lazy(() => import(/* webpackChunkName: 'SortStepList' */ '@/pages/SortStepList')),
  },
  {
    path: '/outbound/sort/abnormalList',
    // component: SortAbnormalList,
    component: React.lazy(() => import(/* webpackChunkName: 'SortAbnormalList' */ '@/pages/SortAbnormalList')),
  },
  {
    path: '/outbound/packbox/list',
    // component: Packbox,
    component: React.lazy(() => import(/* webpackChunkName: 'Packbox' */ '@/pages/Packbox')),
  },
  {
    path: '/outbound/packDetail/detail/:tid',
    // component: PackDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'PackDetail' */ '@/pages/Packdetail')),
  },
  {
    path: '/outbound/packbox/packfind',
    // component: Packfind,
    component: React.lazy(() => import(/* webpackChunkName: 'Packfind' */ '@/pages/Packfind')),
  },
  {
    path: '/outbound/packbox/packstep',
    // component: Packstep,
    component: React.lazy(() => import(/* webpackChunkName: 'Packstep' */ '@/pages/Packstep')),
  },
  {
    path: '/outbound/packbox/packabnor',
    // component: Packabnor,
    component: React.lazy(() => import(/* webpackChunkName: 'Packabnor' */ '@/pages/Packabnor')),
  },
  {
    path: '/outbound/deliver/list',
    // component: Deliver,
    component: React.lazy(() => import(/* webpackChunkName: 'Deliver' */ '@/pages/Deliver')),
  },
  {
    path: '/outbound/deliver/detail',
    // component: DeliverDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'DeliverDetail' */ '@/pages/DeliverDetail')),
  },
  {
    path: '/outbound/deliver/carDetail/:tid',
    // component: DeliverCarDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'DeliverCarDetail' */ '@/pages/DeliverCarDetail')),
  },
  {
    path: '/outbound/deliver/deliverFind',
    // component: Deliverfind,
    component: React.lazy(() => import(/* webpackChunkName: 'Deliverfind' */ '@/pages/Deliverfind')),
  },
  {
    path: '/outbound/deliver/deliverStep',
    // component: DeliverStep,
    component: React.lazy(() => import(/* webpackChunkName: 'DeliverStep' */ '@/pages/DeliverStep')),
  },
  {
    path: '/outbound/deliver/deliverAbnor',
    // component: DeliverAbnor,
    component: React.lazy(() => import(/* webpackChunkName: 'DeliverAbnor' */ '@/pages/DeliverAbnor')),
  },
  {
    path: '/outbound/partialshipment/list',
    // component: PartialShipmentList,
    component: React.lazy(() => import(/* webpackChunkName: 'DeliverAbnor' */ '@/pages/PartialShipmentList')),
  },
  // 拣选
  {
    path: '/outbound/pick/list',
    // component: PickList,
    component: React.lazy(() => import(/* webpackChunkName: 'PickList' */ '@/pages/PickList')),
  },
  {
    path: '/outbound/pick/detail',
    // component: PickDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'PickDetail' */ '@/pages/PickDetail')),
  },
  {
    path: '/outbound/pick/detailList',
    // component: PickDetailList,
    component: React.lazy(() => import(/* webpackChunkName: 'PickDetailList' */ '@/pages/PickDetailList')),
  },
  {
    path: '/outbound/pick/stepList',
    // component: PickStepList,
    component: React.lazy(() => import(/* webpackChunkName: 'PickStepList' */ '@/pages/PickStepList')),
  },
  {
    path: '/outbound/pick/abnormalList',
    // component: PickAbnormalList,
    component: React.lazy(() => import(/* webpackChunkName: 'PickAbnormalList' */ '@/pages/PickAbnormalList')),
  },
  {
    path: '/outbound/pick/repickingManagementPage',
    // component: PickAbnormalList,
    component: React.lazy(() => import(/* webpackChunkName: 'PickAbnormalList' */ '@/pages/RepickingManagementPage')),
  },
  {
    path: '/outbound/pick/RepickingPlanDetail/:tid',
    // component: PickAbnormalList,
    component: React.lazy(
      () =>
        import(
          /* webpackChunkName: 'PickAbnormalList' */ '@/pages/RepickingManagementPage/components/RepickingPlan/RepickingPlanDetail'
        ),
    ),
  },
  {
    path: '/outbound/pick/queue/list',
    // component: PickQueueList,
    component: React.lazy(() => import(/* webpackChunkName: 'PickQueueList' */ '@/pages/PickQueueList')),
  },
  {
    path: '/outbound/pick/queue/detail/:tid',
    // component: PickQueueDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'PickQueueDetail' */ '@/pages/PickQueueDetail')),
  },
  {
    path: '/outbound/pick/manualRemit/list',
    // component: PickManualRemitList,
    component: React.lazy(() => import(/* webpackChunkName: 'PickManualRemitList' */ '@/pages/PickManualRemitList')),
  },
  {
    path: '/outbound/pick/manualRemit/detail/:tid',
    // component: PickManualRemitListDetail,
    component: React.lazy(
      () => import(/* webpackChunkName: 'PickManualRemitListDetail' */ '@/pages/OutboundOrderDetail'),
    ),
  },
  {
    path: '/outbound/one/sorting/list',
    // component: OneSortingList,
    component: React.lazy(() => import(/* webpackChunkName: 'OneSortingList' */ '@/pages/OneSorting/List')),
  },
  {
    path: '/outbound/one/sorting/detail',
    // component: OneSortingDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'OneSortingDetail' */ '@/pages/OneSorting/Detail')),
  },
  {
    path: '/outbound/one/sorting/detailed',
    // component: OneSortingDetailedList,
    component: React.lazy(
      () => import(/* webpackChunkName: 'OneSortingDetailedList' */ '@/pages/OneSortingDetailed/List'),
    ),
  },
  {
    path: '/outbound/sorting/collect/list',
    // component: SortingCollectList,
    component: React.lazy(() => import(/* webpackChunkName: 'SortingCollectList' */ '@/pages/SortingCollect/List')),
  },
  {
    path: '/outbound/sorting/collect/detail',
    // component: SortingCollectDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'SortingCollectDetail' */ '@/pages/SortingCollect/Detail')),
  },
  {
    path: '/outbound/sorting/collect/detailed',
    // component: SortingCollectDetailedList,
    component: React.lazy(
      () => import(/* webpackChunkName: 'SortingCollectDetailedList' */ '@/pages/SortingCollectDetailed/List'),
    ),
  },
  {
    path: '/outbound/codeboard/list',
    // component: CodeBoardlList,
    component: React.lazy(() => import(/* webpackChunkName: 'CodeBoardlList' */ '@/pages/CodeBoard/index')),
  },
  {
    path: '/outbound/codeboard/detail/:tid',
    // component: Detail,
    component: React.lazy(() => import(/* webpackChunkName: 'Detail' */ '@/pages/CodeBoardDetail/index')),
  },
  {
    path: '/outbound/codeboard/codeboardfind',
    // component: CodeBoardFindList,
    component: React.lazy(() => import(/* webpackChunkName: 'CodeBoardFindList' */ '@/pages/CodeBoardFind/index')),
  },
  {
    path: '/outbound/codeboard/codeboardStep',
    // component: CodeBoardStepList,
    component: React.lazy(() => import(/* webpackChunkName: 'CodeBoardStepList' */ '@/pages/CodeBoardStep/index')),
  },
  // 装车
  {
    path: '/outbound/dispatchCar/list',
    // component: DispatchCarList,
    component: React.lazy(() => import(/* webpackChunkName: 'DispatchCarList' */ '@/pages/DispatchCar')),
  },
  // {
  //   path: '/outbound/dispatchCar/detail',
  //   // component: dispatchCarDetail,
  //   component: React.lazy(() => import(/* webpackChunkName: 'dispatchCarDetail' */ '@/pages/DispatchCarDetail')),
  // },
  {
    path: '/outbound/dispatchCar/detail/:tid',
    // component: dispatchCarDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'dispatchCarDetail' */ '@/pages/DispatchCarDetail')),
  },
  {
    path: '/outbound/dispatchCar/cageNoDetail/:tid',
    // component: DispatchCarCageNoDetail,
    component: React.lazy(
      () => import(/* webpackChunkName: 'DispatchCarCageNoDetail' */ '@/pages/DispatchCarCageNoDetail'),
    ),
  },
  {
    path: '/outbound/dispatchCar/dispatchCarFind',
    // component: dispatchCarFind,
    component: React.lazy(() => import(/* webpackChunkName: 'dispatchCarFind' */ '@/pages/DispatchCarFind')),
  },
  {
    path: '/outbound/dispatchCar/dispatchCarStep',
    // component: dispatchCarStep,
    component: React.lazy(() => import(/* webpackChunkName: 'dispatchCarStep' */ '@/pages/DispatchCarStep')),
  },
  // 稽查
  {
    path: '/outbound/inspect/list',
    // component: AuditList,
    component: React.lazy(() => import(/* webpackChunkName: 'Audit' */ '@/pages/Inspect')),
  },
  {
    path: 'outbound/inspect/sku/list',
    component: React.lazy(() => import(/* webpackChunkName: 'Audit' */ '@/pages/SkuInspect')),
  },
  // 包裹分拣
  {
    path: '/outbound/parcelsort/list',
    component: React.lazy(() => import('@/pages/ParcelSort/index')),
  },
  {
    path: '/outbound/parcelsort/detail/:tid',
    component: React.lazy(() => import('@/pages/ParcelSortDetail/index')),
  },
  {
    path: '/outbound/parcelsort/parcelsortfind',
    component: React.lazy(() => import('@/pages/ParcelSortFind/index')),
  },
  // 出库单汇波
  {
    path: '/outbound/pick/manualRemitNew',
    component: React.lazy(() => import(/* webpackChunkName: 'PickManualRemitNew' */ '@/pages/PickManualRemitNew')),
  },

  // 波次透析
  {
    path: '/outbound/waveDialysis/:waveTaskCode',
    component: React.lazy(() => import(/* webpackChunkName: 'WaveDialysis' */ '@/pages/WaveDialysis')),
  },
];
